import stringToColor from '@utilities/stringToColor'
import moment from 'moment'

export function lineDataParserTotal(data) {
  return {
    labels: data.labels,
    datasets: data.datasets.map(lineParserLegendTotal),
  }
}

export function lineParserLegendTotal(chartLine) {
  let color = stringToColor(chartLine.label)
  return {
    label: `${chartLine.label}(${chartLine.data.reduce((a, b) => a + b, 0)})`,
    data: chartLine.data,
    type: 'line',
    fill: false,
    backgroundColor: color,
    borderColor: color,
  }
}

export function lineDataParser(data) {
  return {
    labels: data.labels,
    datasets: data.datasets.map(lineParser),
  }
}

export function lineParser(chartLine) {
  let color = stringToColor(chartLine.label)
  return {
    label: chartLine.label,
    data: chartLine.data,
    type: 'line',
    fill: false,
    backgroundColor: color,
    borderColor: color,
  }
}

export function barDataParser(data) {
  return {
    labels: data.labels,
    datasets: data.datasets.map((ds) => ({ ...ds, backgroundColor: stringToColor(ds.label) })),
  }
}

export function barResponseTimeParser(data) {
  return {
    labels: data.labels,
    datasets: [
      {
        data: data.datasets,
        label: 'tiempos de respuesta',
        backgroundColor: data.labels.map((label) => stringToColor(label)),
      },
    ],
  }
}

export function barCustomerDataParser(data) {
  return {
    labels: data.labels,
    datasets: [
      {
        data: data.datasets,
        label: 'Valoración',
        backgroundColor: data.labels.map((label) => stringToColor(label)),
      },
    ],
  }
}

export function barDataParserCake(data) {
  return {
    labels: data.labels,
    datasets: data.datasets.map((data) => barParserCake(data)),
  }
}

export function barParserCake(data) {
  let color = stringToColor(data.label)
  return {
    label: data.label,
    data: data.data,
    backgroundColor: color,
  }
}

export function doughnutDataParser(data) {
  return {
    labels: data.labels,
    datasets: [
      {
        data: data.data || data.datasets, // TODO: change once backend returns a consistent response on all charts
        backgroundColor: data.labels.map((label) => stringToColor(label)),
      },
    ],
  }
}
export function labelsDoughnutPercentatge(tooltipItem, data) {
  const title = data.labels[tooltipItem.index]
  const total =
    data.datasets[tooltipItem.datasetIndex]._meta[Object.keys(data.datasets[tooltipItem.datasetIndex]._meta)[0]].total
  const currentValue = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
  const percentage = parseFloat(((currentValue / total) * 100).toFixed(1))
  return ` ${title} ${currentValue} (${percentage}%)`
}
export function labelLineParseTime(tooltipItem, data) {
  const currentValue = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
  //get number hours and minutes of current value
  const resultParse = moment().startOf('day').seconds(currentValue).format('H:mm:ss')
  return resultParse
}
